type Props ={
    mensagem?:string
}
export const MensagemAlertAcesso : React.FC<Props> = ({mensagem}) => {
    

    return (<div className='d-flex justify-content-center'><div className='alert alert-alert w-100 text-center'><h2>{mensagem=== '' ? 'Acesso negado' : mensagem}</h2></div></div>)
}